import { render, staticRenderFns } from "./LegalDetails.vue?vue&type=template&id=0c99c32e&scoped=true&"
import script from "./LegalDetails.vue?vue&type=script&lang=js&"
export * from "./LegalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99c32e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c99c32e')) {
      api.createRecord('0c99c32e', component.options)
    } else {
      api.reload('0c99c32e', component.options)
    }
    module.hot.accept("./LegalDetails.vue?vue&type=template&id=0c99c32e&scoped=true&", function () {
      api.rerender('0c99c32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/legal-details/LegalDetails.vue"
export default component.exports